import React, { useEffect, useState } from 'react';
import Fieldset from '../../../../../Components/Fieldset';
import InputCustom from '../../../../../Components/InputCustom';
import SelectDropdown from '../../../../../Components/SelectDropdown';
import { useFiltersContext } from '../contextFilters';
import { Checkbox } from '../../../../../Components/Checkbox/Checkbox';
import { AutocompleteProductIds } from '../AutocompleteProductIds';

const operators = [
	{ value: 'Equals', label: 'Is equal to' },
	{ value: 'NotEquals', label: 'Is not equal to' },
	{ value: 'Contains', label: 'Contains' },
	{ value: 'NotContains', label: 'Does not contain' },
	{ value: 'StartsWith', label: 'Starts with' },
	{ value: 'NotStartsWith', label: 'Does not start with' },
	{ value: 'EndsWith', label: 'Ends with' },
	{ value: 'NotEndsWith', label: 'Does not end with' },
	{ value: 'Like', label: 'Is like' },
	{ value: 'NotLike', label: 'Is not like' },
];

export default function StringContainer({
	data,
	handleChangeFilterByUniqueId,
	selectedTenant,
	needTenantForSearch,
	searchProductFeed,
}) {
	const { tabFilterSelected } = useFiltersContext();
	const [currentValueString, setCurrentValueString] = useState('');
	const [currentValues, setCurrentValues] = useState('');
	const [isAnError, setIsAnError] = useState({ isError: false, message: '' });
	const [valueOperatorSelected, setValueOperatorSelected] = useState(data.op || operators[0].value);
	const [useAutoComplete, setUseAutoComplete] = useState(false);
	const [allowEmpty, setAllowEmpty] = useState(false);
	const [inputValue, setInputValue] = useState('');
	const [searchValue, setSearchValue] = useState('');
	const onChangeAutocomplete = (text) => {
		let txtFormat = text;
		if (txtFormat.length) {
			txtFormat = txtFormat.replace(/(\n)+/g, ';').replace(/;+/g, ';');
		}
		setCurrentValueString(txtFormat);
		handleChangeValues(txtFormat);
	};

	const onChangeWithEmptyValue = () => {
		const newAllowEmpty = !allowEmpty;
		setAllowEmpty(newAllowEmpty);
		if (!newAllowEmpty) {
			const filteredValues = currentValues
				?.split(/[;,""\n]/)
				.filter((x) => x.trim().length > 0)
				.join('\n');
			setCurrentValues(filteredValues);
			setCurrentValueString(filteredValues);
		} else {
			if (!currentValueString && currentValues === undefined) {
				setCurrentValueString('');
				setCurrentValues('');
			}
		}
		handleChangeValuesById(newAllowEmpty);
	};

	const handleSelectOperator = (operator) => {
		setValueOperatorSelected(operator);
	};

	const handleChangeValues = (textAreaValue) => {
		if (!textAreaValue && !allowEmpty) {
			setIsAnError({ isError: true, message: 'input cannot be empty' });
		} else {
			setIsAnError({ isError: false, message: '' });
		}
		setCurrentValues(textAreaValue);
	};

	const getValueOfStringComponent = () => {
		const valueMultiple = tabFilterSelected.value.hasOwnProperty('stringValues');
		if (valueMultiple && data.value['stringValues'] !== null) {
			if (valueOperatorSelected === 'Equals' || valueOperatorSelected === 'NotEquals') {
				onChangeAutocomplete(tabFilterSelected.value['stringValues'].join('\n'));
			}
			setCurrentValues(tabFilterSelected.value['stringValues'].join('\n'));
		} else {
			setCurrentValues('');
		}
	};

	const handleChangeValuesById = (allowEmpty) => {
		let myNewArrayOfCurrentValues = [];
		if (currentValues) {
			myNewArrayOfCurrentValues = currentValues
				.split(/[;,""\n]/)
				.filter((x) => allowEmpty || x.trim().length > 0);
		}
		if (allowEmpty && myNewArrayOfCurrentValues.length === 0) {
			myNewArrayOfCurrentValues.push('');
		}
		handleChangeFilterByUniqueId({
			idFilter: tabFilterSelected.idFilter,
			op: valueOperatorSelected,
			value: { stringValues: myNewArrayOfCurrentValues },
		});
	};

	useEffect(() => {
		handleSelectOperator(tabFilterSelected.op || operators[0].value);
		getValueOfStringComponent();
		if (tabFilterSelected?.value?.stringValues) {
			const hasEmptyValue = tabFilterSelected.value.stringValues.includes('');
			if (hasEmptyValue) {
				setAllowEmpty(true);
				setIsAnError({ isError: false, message: '' });
			}
		}
	}, [tabFilterSelected]);

	useEffect(() => {
		handleChangeValuesById(allowEmpty);
	}, [data, currentValueString, currentValues, valueOperatorSelected, allowEmpty]);

	useEffect(() => {
		if (data.name === 'Id' || data.name === 'Name' ) {
			if (valueOperatorSelected === 'Equals' || valueOperatorSelected === 'NotEquals') {
				setUseAutoComplete(true);
			} else {
				setUseAutoComplete(false);
			}
		} else {
			setUseAutoComplete(false);
		}
	}, [valueOperatorSelected, data]);

	useEffect(() => {
		if (allowEmpty) {
			setIsAnError({ isError: false, message: '' });
		}
	}, [allowEmpty]);

	const addItemToValue = (item) => {
		let newValue = inputValue.trim();
		const value = data.name === 'Id' ? item.id: item.name;
		newValue += newValue.length ? '\n' + value: value;
		handleChange(newValue);
	};

	const handleChange = (value) => {
		onChangeAutocomplete(value);
		setInputValue(value);
	};

	useEffect(() => {
		setInputValue(currentValueString.replace(/;/g, '\n'));
	}, [currentValueString]);

	return (
		<Fieldset label="Value">
			<div className="flex flex_align_start">
				<div className="flex_item_fix mr_10">
					<SelectDropdown
						optionsList={operators}
						value={valueOperatorSelected}
						onChange={(v) => handleSelectOperator(v)}
					/>
				</div>
				<div className="flex_item_full">
					{!useAutoComplete && (
						<>
							<InputCustom
								placeHolder="Enter one item per line or use one of the following separators: ; (semi-colon) , (comma)"
								onChange={(e) => handleChangeValues(e.target.value)}
								value={currentValues}
								type="textarea"
								isAnError={isAnError.message}
								fullWidth={true}
								autogrow={true}
							/>
							<div className="mt_10">
								<Checkbox
									label={'Allow empty value'}
									forcedChecked={allowEmpty}
									onChange={() => onChangeWithEmptyValue()}
									tooltip="If you need to target an empty value, you must check this checkbox. If the box is not checked, any empty values will be removed automatically."
									checkboxSize="s"
								/>
							</div>
						</>
					)}
					{useAutoComplete && (
						<div className="flex_item_full">
							<AutocompleteProductIds
								searchValue={searchValue}
								onChange={(v) => setSearchValue(v)}
								needTenantForSearch={needTenantForSearch}
								searchProductFeed={searchProductFeed}
								selectedTenant={selectedTenant}
								handleSelectidOfProduct={addItemToValue}
							/>
							<div className="mt_8">
								<InputCustom
									type="textarea"
									value={inputValue}
									fullWidth={true}
									autogrow={true}
									maxHeight={500}
									onChange={(e) => handleChange(e.target.value)}
								/>
							</div>
						</div>
					)}
				</div>
			</div>
		</Fieldset>
	);
}